<iframe *ngIf="src" #iframe
        [src]="src"
        frameborder="0"
        width="100%"
        [style.height]="actualHeight"
        (load)="onLoad()"
        allowtransparency></iframe>

<ag-shimmer-loader *ngIf="loading"></ag-shimmer-loader>
